import { createContext, useContext } from 'react';

import { useWorkModeInternal } from './useWorkModeInternal';

export const WorkModeOverrideContext = createContext<Partial<ReturnType<typeof useWorkModeInternal>> | null>(null);

export function useOverrideWorkModeContext() {
  return useContext(WorkModeOverrideContext);
}
